import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { generateRoutesFromConfigs } from "./RoutesUtils";
import PropTypes from "prop-types";
import { createBrowserHistory } from "history";
import { checkPockytEnabled } from "../utils";
import { getReferalSelector } from "../utils/selectorHelpers";

export const history = createBrowserHistory({ window });
export default function AppRoute(props) {
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const isAuthenticated = useSelector(({ Auth }) => Auth?.isAuthenticated);
  const referal = useSelector(getReferalSelector);
  const auth = useSelector(({ Auth }) =>
    isAuthenticated ? Auth.role : "guest"
  );
  const user = useSelector(({ Auth }) => Auth?.user);


  const [config, setConfig] = useState([
    ...generateRoutesFromConfigs(props.routes, auth, { bankEnabled: checkPockytEnabled(fiatService), user, referal }),
  ]);
  useEffect(() => {
    setConfig([...generateRoutesFromConfigs(props.routes, auth, { bankEnabled: checkPockytEnabled(fiatService),  user, referal })]);
  }, [auth, props.routes, fiatService, user, referal]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BrowserRouter window={window}>
      <Routes>
        {config.map((value, index) => (
          <Route key={index} path={value.path} element={<value.component />} />
        ))}
        <Route key={"routes404"} path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

AppRoute.propTypes = {
  routes: PropTypes.array.isRequired,
};
